export default __webpack_public_path__ + "static/media/OCV_LLC@2x.3af826ca.png";